import { Model } from './model';

export class InteractionClassification extends Model {
  action_recommendation: string;

  agent_confidence_score: number;

  agent_error_code: string | null;

  classification: string;

  evidence: InteractionClassificationEvidence | null;

  is_action_required: boolean;

  is_reply_required: boolean;

  language: string;

  reason: string;

  source: string;

  get callouts() {
    return (this.evidence?.callouts ?? []).map((callout) =>
      callout.replace(/(User|Agent):\s*/g, ''),
    );
  }

  get keywords() {
    return this.evidence?.keywords ?? [];
  }

  get evidenceText() {
    return [...this.callouts, ...this.keywords];
  }
}

export interface InteractionClassificationEvidence {
  callouts: string[] | null;

  keywords: string[] | null;
}
